var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Aspect',{attrs:{"type":"achieve","span":"5.5","name":"十三个方面成就"}})}
var staticRenderFns = []

export { render, staticRenderFns }